import store from '@/store'

export default {
  inserted (el, binding, vnode) {
    let value = binding.value
    if (!value) return
    if (!analysisString(value)) {
      el.parentNode.removeChild(el)
    }
  }
}
// 解析参数
// string 传入 String
// 格式为 'material-page||(material-public&&material-private)'
// material-public为权限名称，例子中表达的意思是：当用户有material-page权限，或者同时有material-public和material-private权限时显示此元素
function analysisString (string) {
  // let string = 'material-public||(material-public&&material-private)'
  let array = string.match(/\(|\)|[0-9a-zA-Z\s\-||&&]+/g)
  if (array.length < 1) {
    return true
  } else if (array.length === 1) {
    return getValueFromPermission(array[0])
  }
  return getValue(array)
}
// 解析每一层括号内内容
function getValue (array) {
  let _valueInBracket = valueInBracket()
  while (array.length > 0) {
    let item = array.shift()
    if (item === '(') {
      _valueInBracket(getValue(array))
    } else if (item === ')') {
      return _valueInBracket()
    } else {
      _valueInBracket(item)
    }
  }
  return _valueInBracket()
}
// 将同一个括号内的内容入栈，等待计算
function valueInBracket () {
  return (() => {
    let args = []
    return function () {
      if (arguments.length === 0) {
        let res = args.join('') // 本来可能是['true||','false']这样的，合成一个字符串再给getFragmentValueCurrying去解析
        res = getFragmentValueCurrying(res)
        args = []
        return res
      } else {
        [].push.apply(args, arguments)
      }
    }
  })()
}
// 计算类似 true||false&&false的片段
function getFragmentValueCurrying (string) {
  let fragment = string.match(/&&|[0-9a-zA-Z\s-]+|\|\|/g) // 将值和||、&&符号拆分
  let _orAll = orAll()
  let _andAll = andAll()
  fragment.forEach((value, index, array) => {
    if (value === '||') {
      let andResult = _andAll() // 取得上次总的与的结果
      let newValue = array[index - 1]
      if (andResult !== null) {
        newValue = andResult // 如果总的与有值，则传入或函数，等待进行或。否则将||前面的值传入。
      }
      _orAll(newValue)
    } else if (value === '&&') {
      _andAll(array[index - 1]) // 将&&前面的值存储起来等待&&
    } else if (array[index - 1] === '&&' && (array[index + 1] === '||' || index + 1 === array.length)) {
      _andAll(value) // 传入&&运算最后一个元素
      if (index + 1 === array.length) {
        _orAll(_andAll()) // 如果整个的最后的元素，就传入或函数之中
      }
    } else if (index + 1 === array.length) {
      _orAll(value) // 如果整个的最后的元素，就传入或函数之中
    }
  })
  return _orAll()
}
// 待进行或运算的先存储起来，等待最后进行或运算
function orAll () {
  return (() => {
    let args = []
    return function () {
      if (arguments.length === 0) {
        let res = (args.length > 0) ? or(args) : null
        args = []
        return res
      } else {
        [].push.apply(args, arguments)
      }
    }
  })()
}
// 待进行与运算的先存储起来，等待最后进行与运算
function andAll () {
  return (() => {
    let args = []
    return function () {
      if (arguments.length === 0) {
        let res = (args.length > 0) ? and(args) : null
        args = []
        return res
      } else {
        [].push.apply(args, arguments)
      }
    }
  })()
}

// 与运算，从当前用户权限表中取出对应值再进行
function and (array) {
  if (array.length < 1) {
    throw new Error('请检查参数')
  } else if (array.length === 1) {
    return getValueFromPermission(array[0])
  } else {
    let lastValue = true
    array.forEach(value => {
      lastValue = lastValue && getValueFromPermission(value)
    })
    return lastValue
  }
}
// 或运算，从当前用户权限表中取出对应值再进行
function or (array) {
  if (array.length < 1) {
    throw new Error('请检查参数')
  } else if (array.length === 1) {
    return getValueFromPermission(array[0])
  } else {
    let lastValue = false
    array.forEach(value => {
      lastValue = lastValue || getValueFromPermission(value)
    })
    return lastValue
  }
}
// 从权限表里获取对应的值，如果本来就是true或者false就不去表里找
function getValueFromPermission (value) {
  const permission = store.getters.permissions
  if (value === 'true' || value === true || value === 'false' || value === false) {
    return JSON.parse(value)
  } else {
    let res = (permission[value] === undefined) ? false : permission[value]
    return res
  }
}
